/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Delete_People_LabelInputs */

const cs_settings_teams_delete_people_label = /** @type {(inputs: Settings_Teams_Delete_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé v tomto týmu`)
};

const en_settings_teams_delete_people_label = /** @type {(inputs: Settings_Teams_Delete_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People on this team`)
};

/**
* | output |
* | --- |
* | "People on this team" |
*
* @param {Settings_Teams_Delete_People_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete_people_label = /** @type {((inputs?: Settings_Teams_Delete_People_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Delete_People_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete_people_label(inputs)
	return cs_settings_teams_delete_people_label(inputs)
});